import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-latex-chunk-displayer',
  imports: [MarkdownModule],
  template: `
    @if (chunk(); as chunk) {
      <div class="flex justify-center py-3 my-1">
        <div class="bg-[#f5f8ff] rounded-(--skz-radius-low) px-6 py-3 text-[1.1em]">
          <markdown [data]="latexContent()" katex></markdown>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LatexChunkDisplayerComponent {
  chunk = input.required<any>();

  latexContent = computed(() => {
    const content = this.chunk().mainEdition?.content || '';
    if (!content) return '';
    // If it doesn't start with $$ or $, wrap it in $$ for block rendering
    if (!content.trim().startsWith('$')) {
      return `$$${content}$$`;
    }
    return content;
  });
}
